import React from "react";

export function CpSideMenuDivider() {
  return <div className="cp-divider" />;
}
